import {
  GET_PERFORMANCEAPPRAISALDETAIL,
  GET_PERFORMANCEAPPRAISALDETAIL_SUCCESS,
  GET_PERFORMANCEAPPRAISALDETAIL_FAIL,
  DELETE_PERFORMANCEAPPRAISALDETAIL,
  DELETE_PERFORMANCEAPPRAISALDETAIL_SUCCESS,
  DELETE_PERFORMANCEAPPRAISALDETAIL_FAIL,
  UPDATE_PERFORMANCEAPPRAISALDETAIL,
  UPDATE_PERFORMANCEAPPRAISALDETAIL_SUCCESS,
  UPDATE_PERFORMANCEAPPRAISALDETAIL_FAIL,
  ADD_NEW_PERFORMANCEAPPRAISALDETAIL,
  ADD_PERFORMANCEAPPRAISALDETAIL_SUCCESS,
  ADD_PERFORMANCEAPPRAISALDETAIL_FAIL,
  PERFORMANCEAPPRAISALDETAIL_LOADING,
  PERFORMANCEAPPRAISALDETAIL_RESET,
} from "./actionType";

export const resetPerformanceAppraisalDetailState = (actionType) => ({
  type: PERFORMANCEAPPRAISALDETAIL_RESET,
  payload: { actionType },
});

export const getPerformanceAppraisalDetailSuccess = (actionType, data) => ({
  type: GET_PERFORMANCEAPPRAISALDETAIL_SUCCESS,
  payload: { actionType, data },
});

export const getPerformanceAppraisalDetailFail = (actionType, error) => ({
  type: GET_PERFORMANCEAPPRAISALDETAIL_FAIL,
  payload: { actionType, error },
});

export const getPerformanceAppraisalDetail = data => ({
  type: GET_PERFORMANCEAPPRAISALDETAIL,
  payload: data,
});

export const getPerformanceAppraisalDetailLoading = () => ({
  type: PERFORMANCEAPPRAISALDETAIL_LOADING
});

export const deletePerformanceAppraisalDetail = data => ({
  type: DELETE_PERFORMANCEAPPRAISALDETAIL,
  payload: data,
});

export const deletePerformanceAppraisalDetailSuccess = data => ({
  type: DELETE_PERFORMANCEAPPRAISALDETAIL_SUCCESS,
  payload: data,
});

export const deletePerformanceAppraisalDetailFail = error => ({
  type: DELETE_PERFORMANCEAPPRAISALDETAIL_FAIL,
  payload: error,
});

export const updatePerformanceAppraisalDetail = data => ({
  type: UPDATE_PERFORMANCEAPPRAISALDETAIL,
  payload: data,
});

export const updatePerformanceAppraisalDetailFail = error => ({
  type: UPDATE_PERFORMANCEAPPRAISALDETAIL_FAIL,
  payload: error,
});

export const updatePerformanceAppraisalDetailSuccess = data => ({
  type: UPDATE_PERFORMANCEAPPRAISALDETAIL_SUCCESS,
  payload: data,
});

export const addNewPerformanceAppraisalDetail = data => ({
  type: ADD_NEW_PERFORMANCEAPPRAISALDETAIL,
  payload: data,
});

export const addPerformanceAppraisalDetailSuccess = data => ({
  type: ADD_PERFORMANCEAPPRAISALDETAIL_SUCCESS,
  payload: data,
});

export const addPerformanceAppraisalDetailFail = error => ({
  type: ADD_PERFORMANCEAPPRAISALDETAIL_FAIL,
  payload: error,
});